import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  quizData: [],
  currentQuestionIndex: 0,
  userAnswers: [],
  marks: 0,
  showQuiz: true,
  showResult: false,
};

const InterviewSlice = createSlice({
  name: "quiz",
  initialState,
  reducers: {
    setQuizData(state, action) {
      state.quizData = action.payload;
      state.currentQuestionIndex = 0;
      state.userAnswers = [];
      state.marks = 0;
      state.showQuiz = true;
      state.showResult = false;
    },

    nextQuestion(state) {
      if (state.currentQuestionIndex < state.quizData.length - 1) {
        state.currentQuestionIndex += 1;
      }
    },

    selectAnswer(state, action) {
      state.userAnswers[state.currentQuestionIndex] = action.payload;
    },

    incrementMarks(state, action) {
      state.marks += action.payload;
    },

    showTheResult(state) {
      state.showQuiz = false;
      state.showResult = true;
    },

    resetQuiz(state, action) {
      state.currentQuestionIndex = 0;
      state.userAnswers = [];
      state.marks = 0;
      state.showQuiz = true;
      state.showResult = false;

      if (action.payload) {
        state.quizData = action.payload;
      }
    },
  },
});

export const {
  setQuizData,
  nextQuestion,
  selectAnswer,
  incrementMarks,
  showTheResult,
  resetQuiz,
} = InterviewSlice.actions;

export default InterviewSlice.reducer;
